<template>
    <div
        v-if="totalPoolAmount"
        class="jackpotWidget SportsLobby_Btn_Jackpot"
    >
        <Transition name="fade">
            <div
                v-if="!isInBottomFunction || isShowSportsFooter"
                class="jackpotWidget_title"
                v-on:click="goToJackpotPage"
            >
                <div
                    class="jackpotWidget_title_background"
                    v-bind:class="{ 'jackpotWidget_title_background-eFootball': !isSwitchEFootballToSimulationSportsZoneEnabled }"
                    aria-hidden="true"
                />
            </div>
        </Transition>
        <div
            class="jackpotWidget_prize"
            v-on:click="goToJackpotPage"
        >
            <div class="odometerWrapper odometerWrapper-lg">
                <span class="smallText">{{ i18n.t('jackpot_up_to') }}</span>
                <Odometer
                    v-bind:value="totalPoolAmount"
                    v-bind:thousandSeparator="thousandSeparator"
                    v-bind:decimalSeparator="decimalSeparator"
                />
            </div>
            <div class="jackpotWidget_prize_deco">
                <div
                    class="coin-l"
                    aria-hidden="true"
                />
                <div
                    class="coin-r"
                    aria-hidden="true"
                />
            </div>
            <button
                v-if="showCloseButton"
                type="button"
                class="close SportsLobby_Btn_Jackpot_Close"
                v-on:click.stop="close"
            >
                <SvgIcon iconName="systemIcon_cross" />
            </button>
        </div>
        <div class="jackpotWidget_foot" />
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { defineComponent } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import Odometer from '../common/Odometer.vue';
    import { BetSlipState, RoutePage } from '@/interface/enum';
    import { useTotalPoolAmount } from '@/libraries/composables/useJackpotData';
    import { useJackpotDisplay } from '@/libraries/composables/useJackpotDisplay';
    import { i18n } from '@/libraries/i18n';
    import { getSportsUrl } from '@/libraries/url';
    import { useAccountStore } from '@/stores/accountStore';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';
    import { useHeaderDisplayStore } from '@/stores/headerDisplayStore';
    import { useProductPlatformStore } from '@/stores/productPlatformStore';
    import { useRootStore } from '@/stores/rootStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'JackpotWidget',
        components: {
            Odometer,
            SvgIcon,
        },
        props: {
            showCloseButton: {
                type: Boolean,
                default: true,
            },
            isInBottomFunction: {
                type: Boolean,
                default: false,
            },
        },
        setup() {
            const { isJackpotEFootballInBigEventTheme, isSwitchEFootballToSimulationSportsZoneEnabled } = storeToRefs(useFeatureToggleStore());

            if (isJackpotEFootballInBigEventTheme.value) {
                import('@/scss/components/jackpotWidgetBigEvent.scss');
            } else {
                import('@/scss/components/jackpotWidget.scss');
            }

            const { totalPoolAmount } = useTotalPoolAmount();

            const { isMixParlayMode } = storeToRefs(useRootStore());
            const { setBetSlipState, setIsShowStakePad } = useBetSlipStore();

            const route = useRoute();
            const router = useRouter();

            const goToJackpotPage = () => {
                if (isMixParlayMode.value) {
                    setBetSlipState(BetSlipState.Mini);
                } else {
                    setIsShowStakePad(true);
                }

                if (route.name === RoutePage.Jackpot) return;

                const { isComponentInPp } = storeToRefs(useProductPlatformStore());
                if (isComponentInPp.value) {
                    window.location.href = `${getSportsUrl()}/jackpot`;
                } else {
                    router.push({ name: RoutePage.Jackpot });
                }
            };

            const { isDisplayJackpotWidgetSessionStorage } = useJackpotDisplay();

            const close = () => {
                isDisplayJackpotWidgetSessionStorage.value = false;
            };

            const { displayCurrency } = storeToRefs(useAccountStore());

            const { moneySeparators } = storeToRefs(useAccountStore());
            const { thousandSeparator, decimalSeparator } = moneySeparators.value;

            const { isShowSportsFooter } = storeToRefs(useHeaderDisplayStore());

            return {
                totalPoolAmount,
                goToJackpotPage,
                close,
                displayCurrency,

                thousandSeparator,
                decimalSeparator,
                i18n,

                isShowSportsFooter,
                isSwitchEFootballToSimulationSportsZoneEnabled,
            };
        },
    });
</script>
